<template>
  <div class="assets-offline" ref="assetsOffline">
    <assets-offline-map :map-config="mapConfig" :map-only="true" />
  </div>
</template>

<script>
import AssetsOfflineMap from "@/components/AssetsOfflineMap";

export default {
  components: {
    AssetsOfflineMap
  },
  data: () => ({
    mapConfig: {
      height: 0,
      hasLocateControl: false,
      extendedBounds: 150
    }
  }),
  mounted() {
    this.setMapHeight();
  },
  methods: {
    setMapHeight() {
      const headerHeight = this.$store.state.headerHeight;
      this.mapConfig.height =
        this.$refs.assetsOffline.clientHeight - headerHeight;
    }
  }
};
</script>

<style scoped>
.assets-offline {
  height: 100vh;
  width: 100vw;
  /* Negate .container.is-fluid class' additional margin */
  margin-left: 0;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/index.vue